import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPhilosophy, IPhilosophyInitialState } from "./philosophyModel";
import {
  ActiveInactivePhilosophy,
  PhilosophyDetailsImageUpload,
  createPhilosophy,
  deletePhilosophy,
  getAllActivePhilosophies,
  getAllPhilosophies,
  getPhilosophyByID,
  updatePhilosophy,
} from "./services/philosophy.services";

const initialState: IPhilosophyInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PhilosophyID: null,
  PhilosophyList: [],
  PhilosophyDetail: {
    ID: null,
    Title: "",
    URL: "",
    ShortDescription: "",
    LongDescription: "",
    SequenceNo: null,
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    IsActive: 1,
  },
};

const philosophySlice = createSlice({
  name: "philosophy",
  initialState,
  reducers: {
    clearPhilosophyDetails: (state) => {
      state.PhilosophyDetail = initialState.PhilosophyDetail;
    },
    setPhilosophyID: (state, action) => {
      state.PhilosophyID = action.payload;
    },
    clearPhilosophyID: (state) => {
      state.PhilosophyID = initialState.PhilosophyID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPhilosophies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPhilosophies.fulfilled,
      (state, action: PayloadAction<IPhilosophy[]>) => {
        state.loading = false;
        state.PhilosophyList = action.payload || [];
      },
    );
    builder.addCase(getAllPhilosophies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PhilosophyList = [];
    });
    builder.addCase(createPhilosophy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createPhilosophy.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createPhilosophy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePhilosophy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updatePhilosophy.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePhilosophy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePhilosophy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePhilosophy.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePhilosophy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPhilosophyByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPhilosophyByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PhilosophyDetail = action.payload;
    });
    builder.addCase(getPhilosophyByID.rejected, (state, action) => {
      state.loading = false;
      state.PhilosophyDetail = initialState.PhilosophyDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePhilosophies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePhilosophies.fulfilled,
      (state, action: PayloadAction<IPhilosophy[]>) => {
        state.loading = false;
        state.PhilosophyList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePhilosophies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PhilosophyList = [];
    });
    builder.addCase(ActiveInactivePhilosophy.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactivePhilosophy.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactivePhilosophy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(PhilosophyDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(PhilosophyDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(PhilosophyDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearPhilosophyDetails, clearPhilosophyID, setPhilosophyID } =
  philosophySlice.actions;
export default philosophySlice.reducer;
